import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import AboutPage from "./pages/AboutPage";
import AccessibilityPage from "./pages/AccessibilityPage";
import ComingSoon from "./pages/common/ComingSoon";
import ContactUs from "./pages/ContactUs";
import Feedback from "./pages/Feedback";
import HealthSafetyPage from "./pages/HealthSafetyPage";
import Home from "./pages/Home";
import NetworkComponents from "./components/CommonComponents/NetworkComponents";
import NetworkStatus from "./components/CommonComponents/NetworkStatus";
import NewsUpdatesPage from "./pages/NewsUpdatesPage";
import PageNotFound from "./pages/common/PageNotFound";
import PrivacyDataProtectionPage from "./pages/PrivacyDataProtectionPage";
import ServicesPage from "./pages/ServicesPage";

import "./App.css";
import NewsUpdatesPageOld from "./pages/old/NewsUpdatesPageOld";
import FAQSPage from "./pages/FAQSPage";

const App: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  return (
    <BrowserRouter>
      <NetworkStatus setIsOnline={setIsOnline} />
      {!isOnline ? (
        <NetworkComponents />
      ) : (
        <>
          <Routes>
            <Route path="*" element={<PageNotFound />} />
            <Route path="coming_soon" element={<ComingSoon />} />

            <Route path="/" element={<Home />} />
            <Route path="/newsnew" element={<NewsUpdatesPageOld />} />
            
            <Route path="/about" element={<AboutPage />} />
            <Route path="/accessibility" element={<AccessibilityPage />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/feedback-complaints" element={<Feedback />} />
            <Route path="/health-safety" element={<HealthSafetyPage />} />
            <Route path="/news-updates" element={<NewsUpdatesPage />} />
            <Route path="/privacy-data-protection" element={<PrivacyDataProtectionPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/faqs" element={<FAQSPage />} />
            
          </Routes>
        </>
      )}
      <ToastContainer />
    </BrowserRouter>
  );
};

export default App;
